import * as Types from './types';
import { actionTypes } from './constants';

export const setCookiesGroups = (groupsData: Record<string, boolean>): Types.ISetCookiesGroupsAction => ({
    type: actionTypes.SET_COOKIES_GROUPS,
    payload: groupsData
});

export const setCookiesGroupsInitial = (groupsData: Record<string, boolean>): Types.ISetCookiesGroupsInitialAction => ({
    type: actionTypes.SET_COOKIES_GROUPS_INITIAL,
    payload: groupsData
});

export const setCommonCookieFlag = (isCommonCookieUpdated: boolean): Types.ISetCookieFlagAction => ({
    type: actionTypes.SET_COMMON_COOKIE_FLAG,
    payload: isCommonCookieUpdated
});
